import { Component, OnInit, Input } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { Router } from '@angular/router';
import { FoodServiceService } from 'app/food-service.service';
import { LocalStorage, SessionStorage } from "angular2-localstorage";
import * as $ from 'jquery';
import { PushNotificationsService } from 'angular2-notifications'; 


@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.css']
})
export class HeaderBarComponent implements OnInit {
  loginForm: FormGroup;
  registerForm : FormGroup;
	new:Object={};
  user:Object={};
  tastes:any[]=[];
  categories:any[]=[];
  mobilecategories:any[]=[];
  settings:Object={};
  foods:any[]=[];
  errorMessage:any[]=[];
  catogoryidforfood=''; 
  taste1='';
  taste2='';
  taste3='';
  taste4='';
  errors: MessageBag = new MessageBag();
  logged_in_user=''; 
  tastesofchennai=[];
  tastesofmumbai=[];
  tastesofshanghai=[];
  dubaijuicery=[];
  capcharesult:any;
  capcha:any;
  UserLoggedIn= JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
  constructor( private CommonService: WebApiObservableService,private fb: FormBuilder,
        private validationMessagesService: ValidationMessagesService, private router: Router, private _Food: FoodServiceService,private _pushNotifications: PushNotificationsService) { 
           _pushNotifications.requestPermission();

        }

  ngOnInit() {      
       
        this.loginForm = this.fb.group({
            'mobile': ['', [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]],
            'password': ['', [
                Validators.required,
                Validators.minLength(6)               
            ]]
        });
        this.validationMessagesService
            .seeForErrors(this.loginForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

    this.registerForm = this.fb.group({
            'name': ['', [
                Validators.required,
                Validators.minLength(2)
                
            ]],
            'username': ['', [
                Validators.required,
                Validators.minLength(6)
            ]],
            'email': ['', [
                Validators.required,
                Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)               
            ]],
            'mobile': ['', [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]],
            'password': ['', [
                Validators.required,
                Validators.minLength(6)               
            ]],
            'capcha': ['', [
                Validators.required               
            ]],

        });
        this.validationMessagesService
            .seeForErrors(this.registerForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

    /*Calling Api for generating Capcha*/
    this.CommonService
            .getCapchaService('/users/generate-random-string')
            .subscribe(
                result => this.capcharesult = result,
                error => this.errorMessage = <any>error
            );

    /*Calling Api for taste of locations */
    this.CommonService
            .getService('/tasteoflocations')
            .subscribe(
                result => {this.tastes = result;
                this.taste1=this.tastes[0].name;
                this.taste2=this.tastes[1].name;
                this.taste3=this.tastes[2].name;
                this.taste4=this.tastes[3].name;
                 this.CommonService
                    .getServiceWithComplexObjectAsQueryString('/categories', { status:1,   taste_of_location_id: this.tastes[0].id})
                      .subscribe(
                          result => {this.tastesofchennai= result.items;
                            }
                      ,
                          error => this.errorMessage = <any>error
                      );


                  this.CommonService
                    .getServiceWithComplexObjectAsQueryString('/categories', { status:1,   taste_of_location_id: this.tastes[1].id})
                      .subscribe(
                          result => {this.tastesofmumbai= result.items;
                            }
                      ,
                          error => this.errorMessage = <any>error
                      );


                this.CommonService
                    .getServiceWithComplexObjectAsQueryString('/categories', { status:1,   taste_of_location_id: this.tastes[2].id})
                      .subscribe(
                          result => {this.tastesofshanghai= result.items;
                            }
                      ,
                          error => this.errorMessage = <any>error
                      );

                 this.CommonService
                    .getServiceWithComplexObjectAsQueryString('/categories', { status:1,   taste_of_location_id: this.tastes[3].id})
                      .subscribe(
                          result => {this.dubaijuicery= result.items;
                            }
                      ,
                          error => this.errorMessage = <any>error
                      );


                },
                error => this.errorMessage = <any>error
            
                );
   


    /*Calling Api for Categories */
    // this.CommonService
    //         .getServiceForSearch('/categories','status','10')
    //         .subscribe(
    //             result => this.categories = result.items,
    //             error => this.errorMessage = <any>error
    //         );


     /*Calling Api for Categories for mobile menu*/
    this.CommonService
            .getServiceForSearch('/categories','status','')
            .subscribe(
                result => this.mobilecategories = result.items,
                error => this.errorMessage = <any>error
            );


    /* Calling API for Settings */
    this.callsettings((data) => {
        this.settings = data;
    });

    

  }
  

  callsettings(callback: (data) => void){
      return this.CommonService
            .getService('/settings/1')
            .subscribe(
                 result =>  callback(result),
                error => this.errorMessage = <any>error
            );
  }
  OnSubmit(myModal){

     if(this.capcharesult === this.capcha){
      $('.spin').addClass('loading');
      this.CommonService
            .createService('/users', this.new)
            .subscribe(
                result => {
                  this.logged_in_user=result;                 
                  localStorage.setItem('AUTH_TOKEN',result.auth_key);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result));
                  myModal.close(); 
                  $('.spin').removeClass('loading');                 
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  let options = {
                      body: "Registeration Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => {
                 $('.spin').removeClass('loading');   
                this.errorMessage = <any>error;
                }
            );
     }else{
        alert('Wrong Capcha Entered');
     }
    
  }
  loginError='';  
  OnLogin(myModal){   
    $('.spin').addClass('loading');
     this.CommonService
            .createService('/users/login', this.user)
            .subscribe(
                result =>{
                  this.logged_in_user=result.user;               
                  localStorage.setItem('AUTH_TOKEN',result.auth_token);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result.user));
                  myModal.close();
                  
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  $('.spin').removeClass('loading');
                  let options = {
                      body: "Login Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                   
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => { 
                $('.spin').removeClass('loading');  
                 this.loginError = <any>error}
            );
  }

  refresh(){
    this.loginForm.reset();
    this.registerForm.reset();
  }
 
  
  OnLogOut(){
    localStorage.clear();
    this.UserLoggedIn= null;
    this.refresh();
     this.router.navigate(["home"]);
  }

  OnMyAccount(){
     this.router.navigate(["my-account"]);
  }

  OnEditAccount(){
     this.router.navigate(["edit-account"]);
  }

  /*Function definition for Filters foods according to category id*/
  onCall(id) {
    this.catogoryidforfood = id;
    this.router.navigate(["order-online", id])
  }


   close(){
      
   }
  
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/header-bar/header-bar.component.ts